export default {
  prompt: '提示',
  yes: '确定',
  no: '取消',
  cancel: '取消发送',
  navIndex: {
    joinTeam: '加入公会',
    createTeam: '创建公会',
    teamHome: '泛团首页',
    memberManagement: '成员管理',
    projectManagement: '项目管理',
    report: '报表',
    proOverview: '项目总览',
    userOverview: '用户总览',
    teamBalance: '泛团收益'
  },
  joinTeam: '加入公会',
  teamName: '公会名',
  search: '查询',
  creator: '创建者',
  mainBusiness: '主要业务',
  level: '等级',
  reputation: '信誉',
  operation: '操作',
  application: '申请加入',
  label: {
    picture: '图片',
    text: '文本',
    video: '视频',
    voice: '语音',
    collect: '采集'
  },
  join: {
    comfirmTitle: '正在进行申请操作，是否继续'
  },
  applyJoin: {
    wait: '申请已发送，请等待泛团处理'
  },
  teamInfo: '泛团信息',
  leaveTeam: '脱离泛团',
  disbandTeam: '解散泛团',
  teamNews: '泛团新闻',
  noNews: '暂无新闻',
  showTeamInfo: {
    founder: '创始人',
    createTime: '创建时间',
    id: '泛团ID',
    reputation: '泛团信誉',
    level: '公会等级',
    interestRate: '泛团利率',
    mainBusiness: '主要业务',
    phone: '联系电话',
    email: '联系邮箱',
    introduction: '泛团简介',
    edit: '编辑',
    submit: '提交'
  },
  teamNew: {
    index5: '离开泛团',
    index6: '被移除泛团',
    index7: '加入泛团',
    index8: '任务申请通过',
    index9: '任务结束',
    index10: '未知'
  },
  userManage: {
    manage0: '拼命加载中',
    manage1: '成员权限管理',
    manage2: '批量添加',
    manage3: '成员名',
    manage4: '权限',
    manage5: '操作',
    manage6: '编辑',
    manage7: '删除',
    manage8: '批量添加权限',
    manage9: '项目ID',
    manage10: '公会ID',
    manage11: '用户名',
    manage12: '请选择',
    manage13: '标注权限',
    manage14: '质检权限',
    manage15: '修改权限',
    manage21: '权限不能为空',
    manage22: '成员不能为空',
    manage23: '正在批量添加权限',
    manage24: '是否继续',
    manage26: '修改成功',
    manage27: '此操作将删除任务',
    manage28: '中用户：',
    manage29: '的权限,是否继续?',
    manage31: '提示',
    manage32: '确定',
    manage33: '取消',
    manage34: '删除成功'
  },
  projManage: {
    projManage: '项目管理',
    teamProj: '泛团项目',
    projList: '项目列表',
    projType: '项目类型',
    num: '编号',
    name: '名称',
    type: '类型',
    startTime: '开始时间',
    operation: '操作',
    application: '申请',
    label: {
      voicetag: '语音标注',
      picturetag: '图片标注',
      texttag: '文本标注',
      videotag: '视频标注',
      mixcoll: '混合任务采集',
      textcoll: '文本采集',
      picturecoll: '图片采集',
      voicecoll: '语音采集',
      videocoll: '视频采集'
    },
    applygo: '正在进行申请操作，是否继续',
    applywait: '申请已发送，请等待处理'
  },
  projTeam: {
    processing: '进行中',
    applying: '申请中',
    applyfail: '申请失败',
    taskname: '任务名',
    tasktype: '任务类型',
    starttime: '开始时间',
    operation: '操作',
    userRights: '成员权限管理'
  },
  report: {
    projId: '项目ID',
    search: '查询',
    dataCollTime: '数据采集时间',
    taskNum: '总任务数',
    taskRemain: '总任务剩余数',
    finishNum: '泛团完成任务数',
    progress: '项目进度',
    checkProgress: '质检进度',
    completion: '完成情况',
    check: '质检情况',
    qualified: '合格情况',
    nodata: '暂无数据',
    teamTask: '泛团任务数',
    remainTask: '剩余任务数',
    recoverTask: '回收任务数',
    otherTask: '其他公会任务数',
    qualifiedTask: '合格任务数',
    unreviewedTask: '未审核任务数',
    unqualified: '不合格任务数',
    qualified0: '合格',
    qualified1: '一次合格',
    qualified2: '两次合格',
    qualified3: '多次合格',
    setProId: '请选择项目ID',
    getdata: '数据获取中，请稍后尝试',
    userStatistics: '用户统计',
    userDetails: '用户详情',
    enterUsername: '输入用户名搜索',
    exportData: '导出数据',
    username: '用户名',
    total: '完成',
    qualifiedNo: '不合格',
    notreviewed: '未审核',
    qualifiedrate: '合格率',
    unqualifiedrate: '不合格率',
    totalNum: '完成数',
    qualifiedNum: '合格数',
    unqualifiedNum: '不合格数',
    taskTitle: 'TOP10-完成'
  },
  loading: '拼命加载中',
  balance: {
    balance: '泛团余额(泛函币)',
    totalRevenue: '总收入(泛函币)',
    totalExpenses: '总支出(泛函币)',
    bill: '泛团账单',
    date: '日期',
    remarks: '备注',
    revenue: '收入',
    expenses: '支出',
    fanhanbi: '泛函币'
  },
  create: {
    create: '创建公会',
    noCompany: '公会名禁止包含公司名称',
    noAuthority: '暂无权限',
    certificate: '只有通过企业认证才能创建泛团',
    goCertificate: '前往认证',
    teamName: '泛团名称',
    mainBusiness: '主要业务',
    email: '联系邮箱',
    createNow: '立即创建',
    label: {
      picture: '图片',
      text: '文本',
      video: '视频',
      voice: '语音',
      collect: '采集'
    },
    teamExist: '公会名已存在',
    rules: {
      rlue1: '请输入泛团名称',
      rlue2: '请至少输入一个主要任务',
      rlue3: '请输入联系邮箱 ',
      rlue4: '正在创建公会，是否继续',
      rlue5: '泛团创建成功',
      rlue6: '正在进行脱离泛团的操作，是否继续',
      rlue7: '脱离泛团成功'
    }
  },
  // 2022-4-2开始迭代 暂无英文++@lu
  // 侧边栏++@lu
  // 创建公会这里++@lu
  newnav: {
    joinTeam: '加入泛团',
    createTeam: '创建泛团',
    changeTeam: '修改泛团',
    homePage: '泛团首页',
    projectManagement: '项目管理',
    announcement: '泛团公告',
    onlineAnnouncement: '线上公告',
    memberManagement: '成员管理',
    statement: '报表',
    earnings: '泛团收益',
    setting: '泛团设置',
    announce: '发布公告',
    historyAnnouncement: '历史公告',
    fhAnnouncement: '泛函公告'
  },
  newcreate: {
    enterprise: {
      title: '创建企业性质泛团',
      line1: '仅完成企业认证的用户才可以',
      line2: '企业泛团创建者拥有发布者权限，可以使用泛函平台发布并完成您自己的项目'
    },
    person: {
      title: '创建个人性质泛团',
      line1: '个人实名认证用户仅可创建个人性质泛团',
      line2: '个人性质泛团不拥有同发布者权限，如需发布者权限请联系我们'
    },
    next: '下一步',
    // --------------
    // create
    createTeam: {
      name: '泛团名称：',
      placeholder: '不可包含个人联系方式等信息',
      mainBusiness: '主要业务：',
      picture: '图片',
      text: '文本',
      video: '视频',
      voice: '声音',
      collect: '采集',
      threeD: '3D点云标注',
      tel: '联系电话：',
      email: '联系邮箱：',
      introduce: '泛团简介：',
      yesNo1: '泛团是否开放申请：',
      yesNo2: '加入泛团是否需要审核：',
      back: '返回',
      submit: '提交',
      yes: '是',
      no: '否',
      nameError1: '泛团名称不能超过30个字符',
      nameError2: '泛团名称含有数字',
      nameError3: '泛团名已存在',
      phoneError: '请输入正确的手机号码',
      emailError: '请输入正确的邮箱格式',
      // 一些泛团设置的
      setting: '泛团设置',
      sure: '确定'
    },
    createdTeam: {
      ftName: '泛团名',
      mainBusiness: '主要业务',
      reviewProgress: '审核进度',
      remark: '备注',
      toAudit: '待审核',
      activate: '激活',
      amend: '修改',
      abarbeitung: '整改',
      fail: '激活失败'
    }
  },
  // users-list
  usersList: {
    memberManagement: '成员管理',
    usersList: '成员列表',
    applyList: '申请列表',
    absorb: '吸纳会员',
    username: '用户名',
    teamId: '泛团ID',
    gender: '性别：',
    birthday: '年龄：',
    country: '地区：',
    speciality: '擅长任务：',
    man: '男',
    women: '女',
    roles: '角色',
    plsChoose: '请选择',
    normal: '普通成员',
    manage: '管理员',
    founder: '创始人',
    operation: '操作',
    issue: '发放泛函币',
    delete: '删除',
    pass: '通过',
    refuse: '拒绝',
    remain: '泛团当前泛函币：',
    number: '泛函币数量',
    no: '取 消',
    yes: '确 定',
    inputNum: '请输入泛函币数量',
    inputTips: '泛函币数量不够',
    roleMust: '角色不能为空',
    roleSucc: '角色修改成功',
    roleerr: '角色修改失败',
    delgo: '正在进行删除操作，是否继续',
    delsucc: '删除成功',
    delerr: '删除失败',
    confirm: '请确认是否',
    opesucc: '操作成功',
    fanhansucc: '泛函币发放成功',
    err: '失败'
  },
  teamIndex: {
    title: '泛团名称',
    recruitMembers: '吸纳成员',
    leave: '退出泛团',
    id: '泛团ID',
    createdTime: '创建时间',
    originator: '创始人',
    teamType: '泛团类型',
    finishedCount: '完成项目数',
    businessTeam: '企业泛团',
    personTeam: '个人泛团',
    projectType: '项目类型',
    phone: '联系电话',
    email: '联系邮箱',
    introduction: '泛团简介',
    tuan: '泛团公告',
    han: '泛函公告',
    read: '查看'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/team.js